export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-900">
      <div className="absolute inset-0 z-0">
        <div className="relative w-full h-full">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/9r4qaQdZlug?autoplay=1&mute=1&loop=1&playlist=9r4qaQdZlug&controls=0&showinfo=0&rel=0&modestbranding=1"
            title="南場組 会社紹介動画"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            style={{ 
              pointerEvents: 'none',
              objectFit: 'cover'
            }}
          ></iframe>
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/5 to-black/10"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center w-full">
        <h1 className="text-white text-5xl lg:text-7xl font-bold mb-6 leading-tight">
          株式会社南場組
        </h1>
        <p className="text-white/90 text-xl lg:text-2xl mb-4 font-medium">
          新潟市江南区早通の総合建設業
        </p>
        <p className="text-white/80 text-lg lg:text-xl mb-12 max-w-3xl mx-auto leading-relaxed">
          土木工事・舗装工事・下水道工事・用水路工事<br />
          創業70年以上の確かな技術と信頼で地域のインフラを支えます
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#contact"
            className="bg-teal-600 hover:bg-teal-700 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </a>
          <a
            href="#about"
            className="bg-white/10 hover:bg-white/20 text-white px-10 py-4 rounded-lg text-lg font-semibold transition-all duration-300 backdrop-blur-sm border border-white/30 whitespace-nowrap cursor-pointer"
          >
            会社概要
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <a href="#about" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-4xl animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}
